import { InjectionToken } from '@angular/core';
import { SocketApiParams } from './socket.service';

export const SOCKET_INTERCEPTORS = new InjectionToken<SocketInterceptor>(
  'An interceptor for socket requests that can modify request before sending.');

export interface SocketInterceptor {
  intercept(requestParams: SocketApiParams): SocketApiParams;
}
